var map = {
  "./pl.messages.tsx": [
    "24783",
    [
      8473
    ]
  ],
  "./cs.messages.tsx": [
    "8652",
    [
      243
    ]
  ],
  "./en.messages.tsx": [
    "47195",
    [
      6600
    ]
  ],
  "./hu.messages.tsx": [
    "17402",
    [
      3904
    ]
  ],
  "./de.messages.tsx": [
    "58972",
    [
      5012
    ]
  ],
  "./it.messages.tsx": [
    "52506",
    [
      9898
    ]
  ],
  "./sk.messages.tsx": [
    "36047",
    [
      7803
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 95626;
module.exports = __rspack_async_context;
